import { AppState } from "..";
import {createSelector} from "reselect";

export const getErrorAlertsState = (state: AppState) => state.errorAlerts;
export const getErrorAlerts = createSelector(getErrorAlertsState, (state) => state.items);
export const getNewErrorAlerts = createSelector(getErrorAlerts, (items) => items.filter(
    (item) => item.new
));

